export default __webpack_public_path__ + "static/media/alert.ffe2f634.svg";